'use es6';

import ShareAssetDialogContainer from './ShareAssetDialogContainer';
import { useUserRoleForReport } from '../../../utils/trackingUtils';
import { getId, getName } from '../../../data/schemas/reportSchema';
import { REPORT_OBJECT_TYPE } from 'dashboard-lib/public/emails/emails';
import { getDefaultSavedReportActionEventProperties } from '../../report-action-wrapper';
import ControlsProvider from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareReportDialogContainer = ({
  appUsageTracker,
  report,
  scheduledSharedAsset
}) => {
  const userRole = useUserRoleForReport(report);
  return /*#__PURE__*/_jsx(ControlsProvider, {
    scheduledSharedAsset: scheduledSharedAsset,
    appUsageTracker: appUsageTracker,
    assetSpecificTrackingProps: Object.assign({}, getDefaultSavedReportActionEventProperties(report), {
      role: userRole
    }),
    assetName: getName(report),
    reportId: getId(report),
    objectType: REPORT_OBJECT_TYPE,
    report: report,
    children: /*#__PURE__*/_jsx(ShareAssetDialogContainer, {
      appUsageTracker: appUsageTracker
    })
  });
};
export default ShareReportDialogContainer;